'use strict'

import log from 'loglevel'

export const PROAPPS_ORIGIN = 'https://devcloud.prostock.com.au/api'

class ProAppsClient {
  headers() {
    let headers = new Headers()
    let token = sessionStorage.getItem('access_token')
    if (token != null && token.length > 0) {
      headers.append(
        'Authorization',
        'Bearer ' + sessionStorage.getItem('access_token')
      )
    }
    headers.append('content-type', 'application/json')
    return headers
  }
  getUserByEmail(email) {
    let self = this
    return new Promise(function(resolve, reject) {
      if (email == undefined || email.length < 1) {
        reject(new Error('Email must be set'))
        return
      }
      fetch(PROAPPS_ORIGIN + '/user/' + email, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        headers: self.headers()
      })
        .then(response => {
          if (response.ok) {
            return response.json()
          } else {
            log.error(
              'Server returned ' + response.status + ' : ' + response.statusText
            )
          }
        })
        .then(response => {
          resolve(response[0])
        })
        .catch(err => {
          log.error(err)
          reject(err)
        })
    })
  }
  getPermissionsByEmail(email) {
    let self = this
    return new Promise(function(resolve, reject) {
      if (email == undefined || email.length < 1) {
        reject(new Error('Email must be set'))
        return
      }
      fetch(PROAPPS_ORIGIN + '/livestreamsite/permissionsByEmail/' + email, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        headers: self.headers()
      })
        .then(response => {
          if (response.ok) {
            return response.json()
          } else {
            log.error(
              'Server returned ' + response.status + ' : ' + response.statusText
            )
          }
        })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          log.error(err)
          reject(err)
        })
    })
  }
  getMarket(id) {
    let self = this
    return new Promise(function(resolve, reject) {
      if (id == undefined) {
        reject(new Error('ID must be set'))
        return
      }
      return self
        .getMarkets(id)
        .then(response => {
          if (response.length < 1) {
            throw new Error(
              'Expected 1 item got ' + response.length + ' instead'
            )
          }
          resolve(response[0])
        })
        .catch(err => {
          reject(err)
        })
    })
  }
  getMarkets(id, before, after) {
    let self = this
    return new Promise(function(resolve, reject) {
      let url = new URL(PROAPPS_ORIGIN + '/market_sale')
      if (id != undefined) {
        url.pathname += '/' + id
      }
      if (before != undefined) {
        url.searchParams.append('before', before)
      }
      if (after != undefined) {
        url.searchParams.append('after', after)
      }
      // Get sites
      fetch(url, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        headers: self.headers()
      })
        .then(response => {
          if (response.ok) {
            return response.json()
          } else {
            log.error(
              'Server returned ' + response.status + ': ' + response.statusText
            )
            reject(
              'Server returned ' + response.status + ': ' + response.statusText
            )
          }
        })
        .then(response => {
          // Interpret date type
          response.forEach(market => {
            market.scheduled = new Date(market.scheduled)
            market.timeStarted = new Date(market.timeStarted)
            market.timeFinished = new Date(market.timeFinished)
          })
          resolve(response)
        })
        .catch(err => {
          log.error(err)
          reject(err)
        })
    })
  }
  createMarket(payload) {
    let self = this
    return new Promise(function(resolve, reject) {
      fetch(PROAPPS_ORIGIN + '/market_sale', {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: self.headers(),
        body: JSON.stringify(payload)
      })
        .then(response => {
          if (response.ok) {
            return response.json()
          } else {
            log.error(
              'Server returned ' + response.status + ' : ' + response.statusText
            )
          }
        })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          log.error(err)
          reject(err)
        })
    })
  }
  updateMarket(id, payload) {
    let self = this
    return new Promise(function(resolve, reject) {
      if (id == undefined) {
        reject(new Error('ID must be set'))
        return
      }
      let url = PROAPPS_ORIGIN + '/market_sale/' + id
      fetch(url, {
        method: 'PUT',
        mode: 'cors',
        credentials: 'include',
        headers: self.headers(),
        body: JSON.stringify(payload)
      })
        .then(response => {
          if (response.ok) {
            return response.json()
          } else {
            log.error(
              'Server returned ' + response.status + ' : ' + response.statusText
            )
          }
        })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          log.error(err)
          reject(err)
        })
    })
  }
  deleteMarket(id) {
    // let self = this
    return new Promise(function(resolve, reject) {
      if (id == undefined) {
        reject(new Error('ID must be set'))
        return
      }
      // let url = PROAPPS_ORIGIN + '/market_sale/' + id

      resolve()
    })
  }
  getSite(id, extended) {
    let self = this
    return new Promise(function(resolve, reject) {
      if (id == undefined) {
        reject(new Error('ID must be set'))
        return
      }
      return self
        .getSites(id, extended)
        .then(response => {
          if (response.length < 1) {
            throw new Error(
              'Expected 1 item got ' + response.length + ' instead'
            )
          }
          resolve(response[0])
        })
        .catch(err => {
          reject(err)
        })
    })
  }
  getSites(id, extended) {
    let self = this
    return new Promise(function(resolve, reject) {
      let url = PROAPPS_ORIGIN + '/livestreamsite'
      if (id != undefined) {
        url += '/' + id
      }
      if (extended != undefined) {
        url += '/extended'
      }
      // Get sites
      fetch(url, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        headers: self.headers()
      })
        .then(response => {
          if (response.ok) {
            return response.json()
          } else {
            log.error(
              'Server returned ' + response.status + ' : ' + response.statusText
            )
          }
        })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          log.error(err)
          reject(err)
        })
    })
  }
}

export const proapps = new ProAppsClient()
export default proapps
